export { init } from './client/index.js';
export { nextRouterInstrumentation } from './client/performance.js';
export { captureUnderscoreErrorException } from './common/_error.js';
export { withSentryServerSideGetInitialProps, wrapGetInitialPropsWithSentry } from './client/wrapGetInitialPropsWithSentry.js';
export { withSentryServerSideAppGetInitialProps, wrapAppGetInitialPropsWithSentry } from './client/wrapAppGetInitialPropsWithSentry.js';
export { withSentryServerSideDocumentGetInitialProps, wrapDocumentGetInitialPropsWithSentry } from './client/wrapDocumentGetInitialPropsWithSentry.js';
export { withSentryServerSideErrorGetInitialProps, wrapErrorGetInitialPropsWithSentry } from './client/wrapErrorGetInitialPropsWithSentry.js';
export * from '@sentry/react';
export { Integrations } from '@sentry/react';
export { BrowserTracing } from '@sentry/tracing';
//# sourceMappingURL=index.client.js.map
